import React from 'react'
import { useMutation, queryCache } from 'react-query'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { TeleportToAppSidePanel } from '../../components/SidePanel/SidePanel'
import { Panel } from '../../components/Panel/Panel'
import { useNotifications } from '../../containers/Notifications'
import { MAX_LENGTH } from '../../components/Scales/CharCounter'
import { useWithAuth } from '../App'
import colors from '../../styles/colors'
import { ID } from '../../types/id'
import { ReportEdit } from './utils'
import {
  ReportsFormWrapper,
  ReportsStyledButton,
  ReportsStyledWrapper,
} from '../../styles/Shared'
import WithFocus from '../../components/WithFocus'

type Props = {
  reportId: ID
  id: ID
  name: string | undefined
  resultInterpretation: string | undefined | null
  onClose: () => void
}

const ReportsEditForm = ({
  id,
  reportId,
  name,
  resultInterpretation,
  onClose,
}: Props) => {
  const form = useForm<ReportEdit>({})
  const endpoint = `/report/rest/examination/${id}/report/${reportId}`
  const withAuth = useWithAuth()
  const { notify } = useNotifications()

  const [mutate] = useMutation<any, ReportEdit>(
    (values) =>
      withAuth(endpoint, {
        method: 'PUT',
        payload: values,
      })
        .then((res) => {
          if ('fieldErrors' in res) {
            // @todo notifications
          } else {
            queryCache.refetchQueries(`reports-${id}`)
            notify('Dodano zlecenie edytowania raportu', 'success')
            onClose()
          }
        })
        .catch(console.log),

    {}
  )

  const handleSubmit = form.handleSubmit((values) => {
    const normalizedValues = {
      name: values.name !== '' ? values.name : null,
      resultInterpretation:
        values.resultInterpretation !== '' ? values.resultInterpretation : null,
    }
    return mutate(normalizedValues)
  })
  return (
    <TeleportToAppSidePanel>
      <Panel>
        <WithFocus>
          <ReportsStyledWrapper onSubmit={handleSubmit}>
            <h2>Edytowanie Raportu</h2>
            <ReportsFormWrapper>
              <label>
                Nazwa
                <Input ref={form.register} name="name" defaultValue={name} />
              </label>
              <label>
                Interpretacja wyników
                <TextArea
                  ref={form.register}
                  name="resultInterpretation"
                  maxLength={MAX_LENGTH}
                  defaultValue={resultInterpretation}
                />
              </label>
              <div style={{ width: '100%' }}>
                <ReportsStyledButton
                  color="white"
                  label="Anuluj"
                  onClick={onClose}
                />
                <ReportsStyledButton
                  style={{ marginLeft: '10%' }}
                  label="Zaktualizuj"
                  type="submit"
                />
              </div>
            </ReportsFormWrapper>
          </ReportsStyledWrapper>
        </WithFocus>
      </Panel>
    </TeleportToAppSidePanel>
  )
}

const Input = styled.input`
  min-width: 400px;
  width: 35vw;
  margin: 5px 0px 5px;
  border: ${(props) => (props.disabled ? 'none' : '1px solid #ddd')};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0px 0px 0px 1px ${colors.monza};
  }
`
const TextArea = styled.textarea`
  min-width: 400px;
  max-width: 35vw;
  width: 35vw;
  min-height: 50px;
  margin: 5px 0px 5px;
  border: ${(props) => (props.disabled ? 'none' : '1px solid #ddd')};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0px 0px 0px 1px ${colors.monza};
  }
`

export default ReportsEditForm
